import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { SpinnerLoader } from './components/Spinner';
import { NotFound } from './components/NotFound';
import { TransactionDetail } from './components/TransactionDetail';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Card, Col, Container, Form, Row, Table } from 'react-bootstrap';
import logoCenecVerde from './assets/cenec_1.svg';
import logoCenec from './assets/cenec_2.svg';
import logoChorotega from './assets/chorotega_2.svg';
import countries from '@pixelpay/sdk-core/lib/assets/countries.json'
import states from '@pixelpay/sdk-core/lib/assets/states.json'
import phoneCode from '@pixelpay/sdk-core/lib/assets/formats.json'
import { CreditCard, ShieldCheck } from 'react-bootstrap-icons';
import ReactInputMask from 'react-input-mask';
import { marketCenecCart } from './pixelpay/pixelpay';

const baseUrl = process.env.REACT_APP_API_MARKET_URL

export const MarketPaymentLink = () => {
    document.title = 'Pago Carrito CENEC Market'
    const { idCart } = useParams();
    const [stateSelect, setStateSelect] = useState({})
    const [phoneCodeSelected, setPhoneCodeSelected] = useState(null)
    const entrepreneur = {
        entrepreneurship_name: 'MARKET CENEC'
    }

    const [isLoading, setIsLoading] = useState(false);
    const [cartDetail, setCartDetail] = useState(null);
    const [detailData, setDetailData] = useState(null)
    const [showTransactionDetail, setShowTransactionDetail] = useState(false)
    const [trasactionDetailData, setTrasactionDetailData] = useState(null)
    const [isPosting, setIsPosting] = useState(false);
    const { register, handleSubmit, formState: { errors }, watch, setValue } = useForm();
    watch(["country"])
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    const currentYear = new Date().getFullYear()
    const maxYear = currentYear + 20;
    let years = [];
    for (let i = currentYear; i <= maxYear; i++) {
        years.push(i);
    }


    useEffect(() => {
        async function fnGetCartDetail(idCart) {
            try {
                setIsLoading(true);
                const url = `${baseUrl}/api/payment/get-cart-detail/?idCart=${idCart}`;
                const res = await axios.get(url);
                setCartDetail(res.data)
                setValue('amount', res.data.sum)
            } catch (err) {
                const { response } = err
                setCartDetail(response.data)
            }
            finally {
                setIsLoading(false)
            }
        }
        fnGetCartDetail(idCart)
    }, [idCart, setValue])

    const subTotal = (quantity, price) => quantity * price

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === 'country') {
                if (!!value.country) {
                    setStateSelect(states[value.country])
                    setPhoneCodeSelected(`+${phoneCode[value.country].phone_code}`);
                } else {
                    setStateSelect({})
                    setPhoneCodeSelected(null)
                }
            }
        })

        return () => subscription.unsubscribe()
    }, [watch])

    const onSubmit = async (data) => {
        try {
            setIsPosting(true);
            data = {
                ...data,
                number: data.number.replaceAll(' ', '')
            }
            let startTranscData = {
                email: data.email,
                cardholder: data.cardholder,
                amount: data.amount,
            }
            const res = await marketCenecCart(data, cartDetail.cart, cartDetail.idCart)

            if (res.success) {
                const resData = res.data
                // Save transaction Detail
                const urlSaveTrans = `${baseUrl}/api/payment/post-cart-pixelpay/`;
                const productsObject = cartDetail.cart.map(item => {
                    return {
                        "id": item.id,
                        "quantity": item.quantity,
                        "size": ""
                    }
                })
                const products = cartDetail.cart.map(item => (item.id))
                const quantities = cartDetail.cart.map(item => (item.quantity))

                const dataPost = {
                    "idCart": idCart,
                    "transaction_reference": resData.transaction_reference,
                    "sum": resData.transaction_amount,
                    "productsObject": productsObject,
                    "products": products.join(' '),
                    "quantities": quantities.join(' '),
                    "email": data.email,
                    "name": data.cardholder,
                    "phone": data.phone,
                    "address": `${states[data.country][data.state]}, ${countries[data.country]}`,
                    "city": `${data.address}, ${data.city}`,
                    "result_transaction": res.data
                }
                await axios.post(urlSaveTrans, dataPost);

                //Show Transaction Detail
                setTrasactionDetailData(res)
                setDetailData({
                    correlative: idCart,
                    number: data.number.slice(-4),
                    ...startTranscData,
                })
                setShowTransactionDetail(true)
            } else {
                Swal.fire(
                    'Algo no salió bien!',
                    `${res.message}`,
                    'error'
                )
            }
        } catch (err) {
            const { response } = err
            Swal.fire(
                'Algo no salió bien!',
                `${response?.data?.msg}`,
                'error'
            )
        }
        finally {
            setIsPosting(false)
        }
    }

    if (isLoading) {
        return <SpinnerLoader />
    }
    if (Array.isArray(cartDetail?.cart) && cartDetail.cart.length === 0) {
        return <NotFound />
    }

    return (
        <>
            {
                showTransactionDetail
                    ? <TransactionDetail
                        data={trasactionDetailData}
                        entrepreneur={entrepreneur}
                        detailData={detailData}
                    />
                    :
                    <Container className='' style={{ 'maxWidth': '800px' }} >
                        <div className='d-flex justify-content-center mb-3 ms-2 me-2'>
                            <Card className='card-custom-style '>
                                <Card.Header className='white-bg-color'>
                                    <Row>
                                        <Col md={12} className='d-flex align-items-center justify-content-center'>
                                            <img
                                                src={`${logoCenecVerde}`}
                                                alt='CENEC Market'
                                                className='img-fluid'
                                                width={'50%'}
                                            />
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body>
                                    <Form onSubmit={handleSubmit(onSubmit)}>
                                        <Row className='justify-content-center'>
                                            <Col md="10" className='mb-2'>
                                                <Table size='sm' responsive hover striped>
                                                    <thead>
                                                        <tr>
                                                            <th className='text-start'>Producto</th>
                                                            <th className='text-center'>Precio</th>
                                                            <th className='text-center'>Cantidad</th>
                                                            <th className='text-end'>SubTotal</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            cartDetail?.cart?.map((item, index) => (
                                                                <tr key={`rowCartDetail_${index}`}>
                                                                    <td className='text-start'>{item.title}</td>
                                                                    <td className='text-center'>{item.price.toLocaleString('en-US')}</td>
                                                                    <td className='text-center'>{item.quantity}</td>
                                                                    <td className='text-end'>{subTotal(item.price, item.quantity).toLocaleString('en-US')}</td>
                                                                </tr>
                                                            ))
                                                        }
                                                        <tr>
                                                            <td colSpan={2}></td>
                                                            <td className='text-center'><strong>Total</strong></td>
                                                            <td className='text-end'>{cartDetail?.sum?.toLocaleString('en-US')}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </Col>
                                            <div className="w-100"></div>
                                            <Col md="10" className='mt-3 mb-2'>
                                                <h3 className='fs-5'>Dirección de facturación</h3>
                                            </Col>
                                            <div className="w-100"></div>

                                            <Col md='5' sm='6' xs='12' className='mb-3'>
                                                <div className="form-floating">
                                                    <select
                                                        className="form-select"
                                                        id="selectCountries"
                                                        aria-label="Selecciona país"
                                                        {...register('country',
                                                            {
                                                                required: 'País es requerido'
                                                            }
                                                        )}
                                                    >
                                                        <option value="">Seleccione País</option>
                                                        {
                                                            Object.keys(countries).map(key => (<option key={`country${key}`} value={key}>{countries[key]}</option>))
                                                        }
                                                    </select>
                                                    <label htmlFor="selectCountries">País</label>
                                                </div>
                                                {errors.country && <p className="text-danger">{errors.country.message}</p>}
                                            </Col>

                                            <Col md='5' sm='6' xs='12' className='mb-3'>
                                                <div className="form-floating">
                                                    <select
                                                        className="form-select"
                                                        id="selectStates"
                                                        aria-label="Selecciona país"
                                                        {...register('state',
                                                            {
                                                                required: 'Estado es requerido'
                                                            }
                                                        )}
                                                    >
                                                        <option value="">Seleccione Estado</option>
                                                        {
                                                            !!stateSelect && Object.keys(stateSelect).map(key => (<option key={`state${key}`} value={key}>{stateSelect[key]}</option>))
                                                        }
                                                    </select>
                                                    <label htmlFor="selectStates">Estado</label>
                                                </div>
                                                {errors.state && <p className="text-danger">{errors.state.message}</p>}
                                            </Col>

                                            <Col md='10' sm='12' xs='12' className=' mb-3'>
                                                <div className="form-floating">
                                                    <Form.Control
                                                        type='text'
                                                        id='idCityCustomer'
                                                        placeholder=''
                                                        {...register(
                                                            "city",
                                                            {
                                                                required: 'Ingresa el nombre de tu ciudad'
                                                            }
                                                        )}
                                                    />
                                                    <label htmlFor="idCityCustomer">Ciudad</label>
                                                </div>
                                                {errors.city && <p className="text-danger">{errors.city.message}</p>}
                                            </Col>
                                            <Col md='10' sm='12' xs='12' className=' mb-3'>
                                                <div className="form-floating">
                                                    <Form.Control
                                                        type='text'
                                                        id='idAddressCustomer'
                                                        placeholder=''
                                                        {...register(
                                                            "address",
                                                            {
                                                                required: 'Ingresa un dirección valida'
                                                            }
                                                        )}
                                                    />
                                                    <label htmlFor="idAddressCustomer">Dirección</label>
                                                </div>
                                                {errors.address && <p className="text-danger">{errors.address.message}</p>}
                                            </Col>


                                            <Col md='5' sm='6' xs='12' className='mb-3'>
                                                <div className='input-group'>
                                                    <span className='input-group-text'>{phoneCodeSelected}</span>
                                                    <div className="form-floating">
                                                        <Form.Control
                                                            type='number'
                                                            id='idPhone'
                                                            placeholder='Número de telefono'
                                                            className='form-control'
                                                            {...register('phone',
                                                                {
                                                                    required: 'Número de telefono es requerido'
                                                                }
                                                            )}
                                                        />
                                                        <label htmlFor="idPhone">Número de telefono</label>
                                                    </div>
                                                </div>
                                                {errors.phone && <p className="text-danger">{errors.phone.message}</p>}
                                            </Col>


                                            <Col md='5' sm='6' xs='12' className=' mb-3'>
                                                <div className="form-floating">
                                                    <Form.Control
                                                        type='email'
                                                        id='idEmailCustomer'
                                                        placeholder='correo@electroni.co'
                                                        {...register(
                                                            "email",
                                                            {
                                                                required: true
                                                            }
                                                        )}
                                                    />
                                                    <label htmlFor="idEmailCustomer">Correo electronico</label>
                                                </div>
                                                {errors.email && <p className="text-danger">{errors.email.message}</p>}
                                            </Col>

                                            <Col md="10" className='mt-5 mb-2'>
                                                <h3 className='fs-5'>Detalle de la tarjeta</h3>
                                            </Col>

                                            <Col md='5' sm='12' xs='12' className='mb-3'>
                                                <div className="input-group">
                                                    <span className='input-group-text'><CreditCard /></span>
                                                    <div className="form-floating">
                                                        <ReactInputMask
                                                            type='text'
                                                            mask={"9999 9999 9999 9999"}
                                                            maskChar={" "}
                                                            id='idNumberCard'
                                                            // alwaysShowMask={true}
                                                            placeholder='Número de tarjeta'
                                                            className='form-control'
                                                            {...register('number',
                                                                {
                                                                    required: 'Número de tarjeta es requerido'
                                                                }
                                                            )}
                                                        />
                                                        <label htmlFor="idNumberCard">Número de tarjeta</label>
                                                    </div>
                                                </div>
                                                {errors.number && <p className="text-danger">{errors.number.message}</p>}
                                            </Col>
                                            <Col md='5' sm='12' xs='12' className='mb-3'>
                                                <div className="form-floating">
                                                    <Form.Control
                                                        type='text'
                                                        id='idCustomerName'
                                                        placeholder='Juan Perez'
                                                        {...register(
                                                            "cardholder",
                                                            {
                                                                required: 'Nombre del titular de la tarjeta es requerido'
                                                            }
                                                        )}
                                                    />
                                                    <label htmlFor="idCustomerName">Nombre del titular de la tarjeta</label>
                                                </div>
                                                {errors.cardholder && <p className="text-danger">{errors.cardholder.message}</p>}
                                            </Col>
                                            <div className="w-100"></div>
                                            <Col md='5' sm='6' xs='12' className='mb-3'>
                                                <div className="form-floating">
                                                    <select
                                                        className="form-select"
                                                        id="selectMonth"
                                                        aria-label="Seleccione"
                                                        {...register('expire_month',
                                                            {
                                                                required: 'Mes es requerido'
                                                            }
                                                        )}
                                                    >
                                                        <option value="">Seleccione</option>
                                                        {
                                                            months.map(item => (<option key={`mesExperira${item}`} value={item}>{item}</option>))
                                                        }
                                                    </select>
                                                    <label htmlFor="selectMonth">Mes vencimiento</label>
                                                </div>
                                                {errors.expire_month && <p className="text-danger">{errors.expire_month.message}</p>}
                                            </Col>
                                            <Col md='5' sm='6' xs='12' className='mb-3'>
                                                <div className="form-floating">
                                                    <select
                                                        className="form-select"
                                                        id="selectYear"
                                                        aria-label="Selecciona"
                                                        {...register('expire_year',
                                                            {
                                                                required: 'Año es requerido'
                                                            }
                                                        )}
                                                    >
                                                        <option value="">Seleccione</option>
                                                        {
                                                            years.map(item => (<option key={`añoExperira${item}`} value={item}>{item}</option>))
                                                        }
                                                    </select>
                                                    <label htmlFor="selectYear">Año vencimiento</label>
                                                </div>
                                                {errors.expire_year && <p className="text-danger">{errors.expire_year.message}</p>}
                                            </Col>
                                            <div className="w-100"></div>

                                            <Col md='5' sm='6' xs='12' className=' mb-3'>
                                                <div className="form-floating">
                                                    <Form.Control
                                                        type='number'
                                                        id='idCVVCustomer'
                                                        placeholder=''
                                                        {...register(
                                                            "cvv2",
                                                            {
                                                                required: 'cvv es campo requerido'
                                                            }
                                                        )}
                                                    />
                                                    <label htmlFor="idCVVCustomer">cvv</label>
                                                </div>
                                                {errors.cvv2 && <p className="text-danger">{errors.cvv2.message}</p>}
                                            </Col>
                                            <Col md='5' sm='6' xs='12' className='mb-3'>
                                                <div className="form-floating">
                                                    <Form.Control
                                                        type='number'
                                                        id='idAmount'
                                                        readOnly
                                                        placeholder='Monto a pagar'
                                                        {...register(
                                                            "amount",
                                                            {
                                                                required: 'Monto a pagar'
                                                            }
                                                        )}

                                                    />
                                                    <label htmlFor="idAmount">Monto a pagar</label>
                                                </div>
                                                {errors.amount && <p className="text-danger">{errors.amount.message}</p>}
                                            </Col>

                                            <Col md='10' sm='12' xs='12' className='mb-3'>
                                                <div className="d-grid gap-2">
                                                    <button disabled={isPosting} type="submit" className="btn btn-cenec p-3"><ShieldCheck />  REALIZAR PAGO {isPosting && <SpinnerLoader />}  </button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Card.Body>
                                <Card.Footer className='white-bg-color'>
                                    <Row className='justify-content-center'>
                                        <Col md={10}>
                                            <Row className='justify-content-center cenec-bg-color mx-1 p-3 rounded-1 mb-3 mt-3'>
                                                <Col xl={5} md={5} sm={5} xs={12} className='order-last order-sm-first order-md-first' >
                                                    <div className='d-flex justify-content-center align-items-center'>
                                                        <img src={logoCenec} alt="Logo CENEC" className='img-cenec' />
                                                    </div>
                                                </Col>
                                                <Col xl={2} md={2} sm={2} className='d-none d-sm-block text-center'>
                                                    <div className='vl'></div>
                                                </Col>
                                                <Col xs={12} className='d-block d-sm-none'>
                                                    <div className='hl'></div>
                                                </Col>
                                                <Col xl={5} md={5} sm={5} xs={12} className='order-first order-sm-last order-md-last' >
                                                    <div className='d-flex justify-content-center align-items-center'>
                                                        <img src={logoChorotega} alt="Logo Cooperativa Chorotega" className='img-owner' />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Footer>
                            </Card>
                        </div>
                    </Container>
            }
        </>
    )
}
